import { createSelector } from '@reduxjs/toolkit';
import isSameDay from 'date-fns/esm/isSameDay';
import parseISO from 'date-fns/esm/parseISO';
import orderBy from 'lodash-es/orderBy';
import { IState } from '../';
import { getOperationsUserWarehouses } from '../auth';
import { IDepartingSoonItemSummed } from './departingSoonInterfaces';

export const getDepartingSoonItems = createSelector(
  [
    getOperationsUserWarehouses,
    (state: IState) => state.departingSoon.items,
    (state: IState) => state.inventory.hash,
    (_: IState, { date, hideValidItems }: { date: string | Date | number; hideValidItems: boolean }) => ({
      dateNum: new Date(date).getTime(),
      hideValidItems
    })
  ],
  (warehouseIds, itemArr, inventHash, { dateNum, hideValidItems }): IDepartingSoonItemSummed[] => {
    const filtered = itemArr.filter(x => {
      const doesUserHaveWarehouseAccess = warehouseIds.includes(x.originWarehouseId);
      const availablePhysical = inventHash[x.id] ? inventHash[x.id].availablePhysical : 0;
      const shouldShow = !hideValidItems || x.quantity >= availablePhysical;
      return doesUserHaveWarehouseAccess && isSameDay(parseISO(x.departureDate), dateNum) && shouldShow;
    });

    const summedHash = filtered.reduce<Record<string, IDepartingSoonItemSummed>>((hash, item) => {
      if (hash[item.id]) {
        hash[item.id].quantity += item.quantity;
      } else {
        hash[item.id] = {
          departureDate: item.departureDate,
          description: item.description,
          id: item.id,
          inventDimId: item.inventDimId,
          itemId: item.itemId,
          originWarehouseId: item.originWarehouseId,
          quantity: item.quantity,
          searchName: item.searchName
        };
      }
      return hash;
    }, {});

    return orderBy(Object.values(summedHash), x => x.itemId);
  }
);
